{
  "baseLayout": {
    "backButton": "Yn ôl",
    "menuButton": "Dewislen"
  },
  "reporting": {
    "selectReportButton": "Dewis adroddiad",
    "viewBookingButton": "Gweld archeb"
  },
  "bookingButtons": {
    "addFavJourneyButton": "Ychwanegu taith ffefryn",
    "clearFavJourneyButton": "Clirio taith ffefryn",
    "editBookingButton": "Golygu archeb",
    "shareBookingButton": "Rhannu archeb",
    "sendConfirmationButton": "Anfon cadarnhad",
    "copyBookingButton": "Copïo archeb",
    "returnBookingButton": "Dychwelyd archeb",
    "cancelBookingButton": "Canslo archeb",
    "addToCalendarButton": "Ychwanegu archeb at y calendr",
    "moreActionsButton": "Rhagor o gamau archeb"
  },
  "newBooking": {
    "favJourneyCard": "Archebu taith ffefryn",
    "recentJourneyCard": "Archebu taith ddiweddar",
    "favJourneyEdit": "Golygu disgrifiad taith ffefryn",
    "favJourneyClear": "Clirio taith ffefryn",
    "selectBookingTemplateButton": "Dechrau archeb"
  },
  "masquerading": {
    "changeContactButton": "Newid cyswllt",
    "SelectContactButton": "Dewis cyswllt",
    "clearContactButton": "Clirio'r Cyswllt"
  },
  "bookingForm": {
    "stops": {
      "editStopButton": "Golygu cyfeiriad stop",
      "saveAddressButton": "Cadw cyfeiriad i'r proffil",
      "removeStopButton": "Tynnu stop",
      "reorderStops": "Aildrefnu stopiau",
      "selectFlightCard": "Dewis hediad",
      "removeFlightButton": "Tynnu manylion hediad",
      "stopsInputAccordion": "Gweld mwy o fanylion",
      "mapSearchButton": "Chwilio map",
      "asDirectedButton": "Fel y cyfarwyddwyd",
      "clearSearchButton": "Clirio chwiliad",
      "selectAddressButton": "Dewis cyfeiriad"
    },
    "tariffs": {
      "reverseSort": "Gwrthdroi trefn tariffau"
    }
  },
  "profile": {
    "cards": {
      "makeDefaultCardButton": "Gwneud yn gerdyn diofyn",
      "deleteCardButton": "Dileu cerdyn",
      "selectCard": "Dewis cerdyn"
    },
    "addresses": {
      "addAddressButton": "Ychwanegu cyfeiriad newydd",
      "addressFilterButton": "Hidlo cyfeiriadau",
      "reorderAddresses": "Aildrefnu cyfeiriadau"
    },
    "addContactLinkButton": "Ychwanegu cyswllt"
  },
  "selectProfileCard": "Dewis proffil",
  "clearSelectionButton": "Clirio dewis",
  "refreshChip": "Adnewyddu cynnwys",
  "passwordToggle": "Newid gwelededd cyfrinair",
  "countryInputField": "Dewis gwlad / rhanbarth",
  "localeInput": "Dewiswch iaith",
  "viewBooking": {
    "openDocument": "Agor dogfen"
  }
}
